import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/artistService';
import { SectionHeader } from '../../components/ui/SectionHeader';

export const Login: React.FC = () => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (login(password)) {
            navigate('/admin/dashboard');
        } else {
            setError('Invalid password');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-black/50 p-8 rounded-xl border border-white/10 backdrop-blur-md">
                <SectionHeader title="Admin Access" subtitle="Restricted Area" />
                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="password" className="sr-only">Password</label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-700 placeholder-gray-500 text-white bg-black focus:outline-none focus:ring-astral-purple focus:border-astral-purple focus:z-10 sm:text-sm"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    </div>

                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}

                    <div>
                        <button
                            type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-astral-purple hover:bg-astral-purple/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-astral-purple"
                        >
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
